import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var fr = {
  language: 'fr',
  country: 'fr',
  name: 'Français',
  embeddedLocale: merge(error, login),
  flags: ['FR'],
};

export { fr as default };
